import { Component } from '@angular/core';

@Component({
  selector: 'lib-arrk-cms-libs',
  imports: [],
  templateUrl: './arrk-cms-libs.html',
  styleUrl: './arrk-cms-libs.css'
})
export class ArrkCmsLibs {}
